/**
 * Formats a Date object to YYYY-MM-DD string format
 * @param {Date} date - The date to format
 * @returns {string} Formatted date string
 */
export const formatDateToString = (date) => {
  if (!date || !(date instanceof Date)) {
    return new Date().toISOString().split('T')[0];
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const formatDateToStringWithoutPadding = (date) => {
  if (!date || !(date instanceof Date)) {
    return new Date().toDateString().split('T')[0];
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  return `${year}-${month}-${day}`;
};

export const formatDateWithoutLocalDate = (date) => {
  if (!date || !(date instanceof Date)) {
    return new Date().toDateString().split('T')[0];
  }

  const [datePart, timePartRaw] = date.toISOString().split("T");
  const timePart = timePartRaw ? timePartRaw.replace(/Z$/, '').split('.')[0] : "";
  return `${datePart} ${timePart}`;
}